<template>
  <div class="sonic-boom-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Ma = v / c | 激波角 sinθ = 1/Ma$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Wave Shells -->
          <g v-for="shell in waveShells" :key="shell.id">
             <circle :cx="shell.x" :cy="120" :r="shell.r" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="1" />
          </g>

          <!-- The Mach Cone (Shock Wave) -->
          <g v-if="mach >= 1">
             <line :x1="posX" y1="120" :x2="posX - 200" :y2="120 - 200/mach" stroke="#fff" stroke-width="2" opacity="0.6" />
             <line :x1="posX" y1="120" :x2="posX - 200" :y2="120 + 200/mach" stroke="#fff" stroke-width="2" opacity="0.6" />
             <!-- Cloud condensation area -->
             <path :d="`M ${posX-20},120 Q ${posX-50},${120-40} ${posX-80},120 Q ${posX-50},${120+40} ${posX-20},120`" fill="rgba(255,255,255,0.2)" />
          </g>

          <!-- The Aircraft -->
          <g :transform="`translate(${posX}, 120)`">
             <path d="M -15,-5 L 10,0 L -15,5 Z" fill="#ff4757" />
             <text x="10" y="-10" fill="#ff4757" font-size="8">Ma = {{ (posX / 20).toFixed(1) }}</text>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>设定马赫数 Ma: {{ mach.toFixed(2) }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节飞行速度 (马赫数)</label>
             <el-slider v-model="mach" :min="0.5" :max="2.5" :step="0.01" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当物体运动速度超过声速（Ma > 1）时，它发出的所有声波被“抛”在身后，并在飞机的运动路径前沿累积形成极强的**压力激波**。这种激波在空间中形成一个锥形区域（马赫锥）。当马赫锥扫过地面时，人们会听到震耳欲聋的“音爆”。伴随而来的局部压强突变常会使空气中的水蒸气液化，形成壮丽的“音爆云”。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SonicBoomViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mach: 1.2,
      posX: 200,
      waveShells: [],
      timer: null
    }
  },
  methods: {
    update() {
       this.posX = (this.posX + this.mach * 2) % 400;
       
       // Emit a new wave Shell
       if (Math.random() > 0.8) {
          this.waveShells.push({
             id: Math.random(),
             x: this.posX,
             r: 0
          });
       }

       this.waveShells.forEach((s, idx) => {
          s.r += 2; // Speed of sound constant
          if (s.r > 300) this.waveShells.splice(idx, 1);
       });

       this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.sonic-boom-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 255, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
